import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AgeVerificationModal from './AgeVerificationModal';

const ProtectedRoute = ({ children }) => {
  const { user, loading, refreshUser } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#0EA5E9]"></div>
          <p className="mt-4 text-[#6B7280]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Show age verification modal for users without DOB (Google Auth users)
  if (!user.age_verified && user.role !== 'admin') {
    return (
      <>
        {children}
        <AgeVerificationModal onVerified={refreshUser} />
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
